import { useEffect } from 'react';

import { inBrowser } from '@/utils/capabilities';

const COMETLY_SCRIPT_SRC =
  'https://m.littlebird.ai/script.js?uid=e691f6-4503599721000002-cba2a7-s&domains=app.littlebird.ai,littlebird.ai';

export function CometlyPixel() {
  useEffect(() => {
    if (!inBrowser()) return;

    const script = document.createElement('script');
    script.src = COMETLY_SCRIPT_SRC;
    script.dataset.ctag = 'cmt';
    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
    };
  }, []);

  return null;
}
